import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { PublicProfileParams, PublicProfileTicket, RedeemTicketParams } from 'src/common/interfaces/public-profile';
import { PUBLIC_PROFILE_URL } from 'src/features/public-profile/public-profile.slice';
import { RTKQueryTag } from 'src/common/constants';

export const publicProfileTicketsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublicProfileTickets: builder.query<ApiResponse<PublicProfileTicket[]>, PublicProfileParams>({
      query: ({ user }: PublicProfileParams) => ({
        url: `${PUBLIC_PROFILE_URL}/tickets`,
        params: {
          user,
        },
      }),
      providesTags: [RTKQueryTag.Tickets],
    }),
    redeemTicket: builder.mutation<ApiResponse<null>, RedeemTicketParams>({
      query: ({ ticketName }) => ({
        method: 'POST',
        url: 'games/tickets/redeem',
        body: { ticketName },
      }),
      invalidatesTags: [RTKQueryTag.Tickets],
    }),
  }),
});

export const { useGetPublicProfileTicketsQuery, useRedeemTicketMutation } = publicProfileTicketsApiSlice;
